import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

import { RdsFormatSelectedCountPipe } from './format-selected-count.pipe';
import { RdsFormatSelectionListComponent } from './format-selection-list.component';

const COMPONENTS = [RdsFormatSelectionListComponent];
const PIPES = [RdsFormatSelectedCountPipe];

@NgModule({
  imports: [CommonModule, FlexLayoutModule, MatListModule, MatIconModule],
  declarations: [COMPONENTS, PIPES],
  exports: [COMPONENTS]
})
export class RdsPackageFormatSelectionModule {}

export * from './format-selection-list.component';
